export const API_STATUS = {
  FATAL: 'Fatal',
  ERROR: 'Error',
  FAIL: 'Fail',
  WARN: 'Warn',
  INFO: 'Info',
  OK: 'OK'
};
